// components/AdvanceInfo/component

import template  from './component.jade'
import Store     from 'Store'
import parseLink from 'lib/filters/parseBillLink'
import parseTime from 'lib/filters/parseUnixTime'
import onClick   from 'lib/methods/onClick'

var name = 'advance-info'
var url = '/api/AdvanceInfo'

const store = new Store(name)

export default {

  name: name,
  template: template(),
  props: [],
  mixins: [parseLink, parseTime, onClick],

  data() {
    return {
      name: name,
      url: url,
    }
  },
  ready() {
    this.$set('data', store.$get(this) )
  },

  computed: {
    // сумма всех полей summa счета (строка в таблице - всего)
    summas() {
      var data = this.$get('data')

      var advance = data.tables['advance'].reduce((summa, str) => summa + str.summa, 0)
      var debt    = data.tables['debt'].reduce((summa, str) => summa + str.summa, 0)

      return { advance, debt }
    },
  },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/advance-info/component.js
 **/